import React from "react"

const NurseLunchStatsComponent = ({ nurseSchedule, breakDuration = 30 }) => {
	// Calculate lunch break metrics
	const totalNurses = nurseSchedule.length

	// Nurses who have started their lunch break
	const startedLunch = nurseSchedule.filter(nurse => nurse.actualLunchBreakStart).length

	const lateToLunch = nurseSchedule.filter(nurse => {
		return (
			nurse.actualLunchBreakStart &&
			nurse.actualLunchBreakStart > nurse.scheduledStartTime + 240
		)
	}).length

	// Nurses who have completed their lunch break with proper duration
	const completedLunch = nurseSchedule.filter(
		nurse =>
			nurse.actualLunchBreakEnd &&
			nurse.actualLunchBreakStart &&
			nurse.actualLunchBreakEnd - nurse.actualLunchBreakStart >= breakDuration
	).length

	return (
		<div className="bg-gray-900/5 shadow-sm rounded-lg border border-gray-200">
			<div className="mt-1 flex items-center gap-x-1.5">
				<div className="flex items-center space-x-2 m-2">
					<div className="relative flex-none p-1">
						<div className="absolute inset-0 rounded-full bg-emerald-500/20 animate-pulse-ring"></div>
						<div className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
					</div>
					<p className="text-xs leading-5 text-emerald-500">Live - Lunch Break Status</p>
				</div>
			</div>

			<dl className="grid grid-cols-5 gap-px bg-gray-900/5">
				{/* First Box: Lunch Break Progress */}
				<div
					key="LunchProgress"
					className="flex flex-col bg-white px-4 py-5 sm:px-4 xl:px-6 col-span-3"
				>
					<dt className="text-sm font-medium leading-6 text-gray-500 mb-4">
						Lunch Break Progress
					</dt>
					<dd className="w-full text-xl font-medium leading-6 tracking-tight text-gray-900">
						<div className="flex flex-wrap items-center justify-between space-x-4">
							<div className="inline-flex items-center space-x-2">
								<span>{startedLunch}</span>
								<span className="inline-flex items-center px-2 py-0.5 rounded-full text-sm font-medium bg-blue-200 text-blue-800">
									Started Lunch
								</span>
							</div>
							<div className="inline-flex items-center space-x-2">
								<span>{completedLunch}</span>
								<span className="inline-flex items-center px-2 py-0.5 rounded-full text-sm font-medium bg-green-200 text-green-800">
									Completed Lunch
								</span>
							</div>
							<div className="inline-flex items-center space-x-2">
								<span>{totalNurses - startedLunch}</span>
								<span className="inline-flex items-center px-2 py-0.5 rounded-full text-sm font-medium bg-gray-200 text-gray-800">
									Not Started
								</span>
							</div>
						</div>
					</dd>
				</div>

				{/* Second Box: Lunch Timing */}
				{/* <div
					key="EarlyLunch"
					className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-2 bg-white px-4 py-5 sm:px-4 xl:px-6 col-span-1"
				>
					<dt className="text-sm font-medium leading-6 text-gray-500">Early to Lunch</dt>
					<dd className="w-full flex-none text-3xl font-medium leading-10 tracking-tight text-gray-900">
						<div>{earlyToLunch}</div>
						<div className="text-sm text-gray-500">
							({Math.round((earlyToLunch / totalNurses) * 100) || 0}%)
						</div>
					</dd>
				</div> */}

				{/* Third Box: Late to Lunch */}
				<div
					key="LateLunch"
					className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-2 bg-white px-4 py-5 sm:px-4 xl:px-6 col-span-2"
				>
					<dt className="text-sm font-medium leading-6 text-gray-500">
						Late Lunch Break Percentage ({">"} 4 hrs post shift start time)
					</dt>
					<dd className="w-full flex-none text-3xl font-medium leading-10 tracking-tight text-gray-900">
						<div className="relative inline-block">
							{lateToLunch}
							<span className="absolute bottom-1 -right-8 text-base text-gray-500">
								/ {totalNurses}
							</span>
						</div>
						<div className="text-sm text-gray-500">
							({Math.round((lateToLunch / totalNurses) * 100) || 0}%)
						</div>
					</dd>
				</div>
			</dl>
		</div>
	)
}

export default NurseLunchStatsComponent
